module.exports = __webpack_public_path__ + "img/feedback.afba5cd2.svg";